import {
  type DefaultCmsResponse,
  type DefaultCmsDataResponse,
  type DefaultCmsError,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type { Banner } from './types';
import { apiRoutes } from '@/api/api-routes';

export const getHomeBannerFn = async () => {
  const response = await publicHttpClient.get<
    DefaultCmsResponse<DefaultCmsDataResponse<Banner>>
  >(`${process.env.NEXT_PUBLIC_CMS_API_URI}${apiRoutes.cms.homeBanner.list}`);
  return response.data;
};

export const useGetHomeBanner = (
  opts?: Omit<
    UseQueryOptions<
      DefaultCmsResponse<DefaultCmsDataResponse<Banner>>,
      DefaultCmsError,
      DefaultCmsResponse<DefaultCmsDataResponse<Banner>>,
      [string]
    >,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery({
    queryKey: [
      `${process.env.NEXT_PUBLIC_CMS_API_URI}/api/home-banner?populate[items][populate]=*&filters[items][type][$eq]=aifood`,
    ],
    queryFn: getHomeBannerFn,
    ...opts,
  });
